/**
 * Empty expo structure (for creating new expo)
 */
export const structPrototype = {
  start: { type: "START", expoTime: 0 },
  finish: { type: "FINISH" },
  screens: [],
  files: [{ files: [] }],
};
